import {
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useMutation, useQueryClient} from '@github-ui/react-query'
import {threadPreviewsQueryKey} from '../page-data/loaders/use-thread-previews'
import {useMarkersActions, usePullRequestBasePath, useUnresolvedConversationCountActions} from '../stores/selectors'
import type {FileKey, LineKey} from '@github-ui/diff-lines/types'

export function useUnresolveThreadMutation(filePath: string, lineMarkersKey: LineKey | FileKey) {
  const basePath = usePullRequestBasePath()
  const apiUrl = `${basePath}/page_data/${PageData.unresolveThread}`
  const queryClient = useQueryClient()
  const {updateThread} = useMarkersActions()
  const {incrementUnresolvedConversationCount} = useUnresolvedConversationCountActions()

  return useMutation({
    mutationFn: async ({threadId}: {threadId: string}) => {
      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          threadId,
        },
      })

      throwErrorsIfBadResponse(response)
    },
    onSuccess: (_data, variables) => {
      updateThread(Number(variables.threadId), filePath, lineMarkersKey, oldThread => {
        if (oldThread) {
          return {...oldThread, isResolved: false, resolvedBy: undefined, resolutionReason: undefined}
        }
      })

      incrementUnresolvedConversationCount()

      // invalidate pullRequestFilesToolbar queries
      return queryClient.invalidateQueries({
        queryKey: threadPreviewsQueryKey(basePath),
      })
    },
  })
}
